module.exports = __webpack_public_path__ + "img/rewards1.7e22e26d.png";